import React from 'react'
const SvgArrrowDown = props => (
  <svg fill='none' width={14} height={14} {...props}>
    <defs>
      <clipPath id='arrrow_down_svg__a'>
        <rect width={14} height={14} rx={0} />
      </clipPath>
    </defs>
    <g clipPath='url(#arrrow_down_svg__a)'>
      <path
        d='M2.453 5.02l4.083 5.444c.233.31.7.31.933 0l4.084-5.445a.583.583 0 00-.467-.933H2.919a.583.583 0 00-.466.933z'
        fill='#111'
      />
    </g>
  </svg>
)
export default SvgArrrowDown
